var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgProgressIllustration = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 41,
  viewBox: "0 0 40 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.863 0.640625C28.794 0.640625 27.1167 2.31791 27.1167 4.38694V27.9887C27.1167 30.0578 28.794 31.735 30.863 31.735C32.932 31.735 34.6093 30.0578 34.6093 27.9887V4.38694C34.6093 2.31791 32.932 0.640625 30.863 0.640625ZM16.2524 13.3781C16.2524 11.3091 17.9297 9.63178 19.9987 9.63178C22.0677 9.63178 23.745 11.3091 23.745 13.3781V27.9887C23.745 30.0578 22.0677 31.735 19.9987 31.735C17.9297 31.735 16.2524 30.0578 16.2524 27.9887V13.3781ZM5.38806 19.7468C5.38806 17.6778 7.06534 16.0005 9.13438 16.0005C11.2034 16.0005 12.8807 17.6778 12.8807 19.7468V27.9887C12.8807 30.0578 11.2034 31.735 9.13438 31.735C7.06534 31.735 5.38806 30.0578 5.38806 27.9887V19.7468Z",
  fill: "url(#paint0_linear_5094_23857)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.4882 34.229L34.1063 36.452C34.7807 36.8664 34.7807 37.8465 34.1063 38.2608L30.4882 40.4838C29.7809 40.9183 28.8711 40.4095 28.8711 39.5794V38.6676L6.88628 38.6676C6.16212 38.6676 5.57507 38.0806 5.57507 37.3564C5.57507 36.6323 6.16212 36.0452 6.88628 36.0452L28.8711 36.0452V35.1334C28.8711 34.3034 29.7809 33.7945 30.4882 34.229Z",
  fill: "#1A2B7B"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_5094_23857",
  x1: 34.6093,
  y1: 0.640619,
  x2: -0.868813,
  y2: 11.9749,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB661"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF70DB"
})))));
export default SvgProgressIllustration;